import {inject, Injectable} from '@angular/core';
import {Observable, throwError} from "rxjs";
import {APIResponse} from "../../../models/Response";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {catchError, tap} from "rxjs/operators";
import {environment} from "../../../../environments/environment";
import {CreateUpdateGeoFencePolicyResponse, PolicySet} from "../models/geo-fence";
import {ActiveGeoFenceOrganization} from "../../../models/organization";
import {GeoFenceStoreService} from "./geo-fence-store.service";

@Injectable({
    providedIn: 'root'
})
export class GeoFencePoliciesService {
    private apiServerUrl = environment.apiBaseUrl;
    private http = inject(HttpClient);

    //Services and injections
    private geoFenceStoreService = inject(GeoFenceStoreService);

//     /api/geo-fence-policy/2/getGeoFencePolicy
    getGeoFencePolicy(accountIds: string, orgId: number): Observable<APIResponse<PolicySet>> {
        const headers = new HttpHeaders().set("accountIds", accountIds);
        return this.http
            .get<APIResponse<any>>(`${this.apiServerUrl}/geo-fence-policy/${orgId}/getGeoFencePolicy`, {
                headers: headers,
            })
            .pipe(
                catchError((error) => throwError(() => error))
            );
    }


//     /api/geo-fence-policy/2/updateGeoFencePolicy -> Enable/Disable Geo-Fence Policy
    updateGeoFencePolicy(accountId: string, isGeoFencingActive: boolean, orgId: number, policySet: PolicySet): Observable<APIResponse<CreateUpdateGeoFencePolicyResponse>> {
        policySet.isGeoFencingActive = isGeoFencingActive;
        const headers = new HttpHeaders().set("accountIds", accountId);
        return this.http
            .post<APIResponse<any>>(`${this.apiServerUrl}/geo-fence-policy/${orgId}/updateGeoFencePolicy`, policySet, {
                headers: headers,
            })
            .pipe(
                catchError((error) => throwError(() => error))
            );
    }

    getGeoFenceActiveDetails(): Observable<APIResponse<ActiveGeoFenceOrganization[]>> {
        return this.http
            .get<APIResponse<ActiveGeoFenceOrganization[]>>(`${this.apiServerUrl}/geo-fence-policy/getGeoFenceActiveDetails`)
            .pipe(
                tap({
                    next: (response) => {
                        this.geoFenceStoreService.setGeoFencingActiveOrg(response.data || []);
                        // find if any org has geo fence admin panel active
                        const isActive = response.data?.some(org => org.isGeoFenceAdminPanel) || false;
                        this.geoFenceStoreService.setGeoFencingActiveState(isActive);
                    },
                    error: () => {
                        this.geoFenceStoreService.setGeoFencingActiveOrg([]);
                        this.geoFenceStoreService.setGeoFencingActiveState(false);
                    }
                })
            );
    }
}
